import { render, staticRenderFns } from "./salesLeadListSkeleton.vue?vue&type=template&id=50812120&scoped=true&"
import script from "./salesLeadListSkeleton.vue?vue&type=script&lang=js&"
export * from "./salesLeadListSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./salesLeadListSkeleton.vue?vue&type=style&index=0&id=50812120&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50812120",
  null
  
)

export default component.exports